<template>
  <el-tag
    :type="getTagType"
    :effect="effect || 'light'"
    :size="size || 'default'"
    class="application-status-tag"
  >
    {{ getStatusText }}
  </el-tag>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  status?: string | null;
  effect?: 'plain' | 'light' | 'dark';
  size?: 'large' | 'default' | 'small';
}>();

// 获取标签类型
const getTagType = computed(() => {
  if (!props.status) return 'info';
  
  switch (props.status) {
    case 'submitted':
      return 'primary';
    case 'in_review':
      return 'warning';
    case 'accepted':
      return 'success';
    case 'rejected':
      return 'danger';
    case 'withdrawn':
      return 'info';
    case 'not_started':
    default:
      return 'info';
  }
});

// 获取状态文本
const getStatusText = computed(() => {
  if (!props.status) return '未设置';
  
  const statusMap: Record<string, string> = {
    'not_started': '未开始',
    'draft': '草稿',
    'submitted': '已提交',
    'in_review': '审核中',
    'accepted': '已录用',
    'rejected': '已拒绝',
    'withdrawn': '已撤回',
    'pending': '待处理'
  };
  
  return statusMap[props.status] || props.status;
});
</script>

<style scoped>
.application-status-tag {
  border-radius: 4px;
  padding: 0 6px;
  font-size: 12px;
}
</style> 